import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
const JournalHighlight = () => {
  const $ = _c(17);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0,
      rotateY: 20,
      rotateX: 10
    };
    t1 = {
      opacity: 1,
      rotateY: 0,
      rotateX: 0
    };
    t2 = {
      once: true
    };
    t3 = {
      duration: 1,
      ease: "easeOut"
    };
    t4 = {
      rotateY: -5,
      rotateX: 5,
      scale: 1.02
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      transformStyle: "preserve-3d"
    };
    t6 = <div className="absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-black/60 to-transparent z-10 pointer-events-none" />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="font-body text-[8px] tracking-[0.3em] uppercase text-[#DF6D2A] mb-4">Vol. 1 • Issue 1</p>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <br />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <br />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="text-center">{t7}<h3 className="font-display text-[24px] sm:text-[30px] md:text-[40px] leading-[1.1] text-[#F4EFE6] uppercase">The {t8}Girmitiya {t9}Council <br />Journal</h3></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="w-full lg:w-[45%] flex justify-center perspective-[1000px]"><motion.div initial={t0} whileInView={t1} viewport={t2} transition={t3} whileHover={t4} className="relative w-[85%] sm:w-[70%] md:w-[60%] lg:w-[70%] aspect-[3/4] bg-[#0F1C2E] shadow-[20px_20px_60px_rgba(15,28,46,0.3)] border-l-8 border-[#0F1C2E] cursor-pointer" style={t5}>{t6}<div className="absolute inset-0 p-5 sm:p-6 md:p-8 flex flex-col justify-between border border-white/10 m-1.5 sm:m-2">{t10}<div className="text-center"><div className="w-8 h-px bg-[#C9A84C] mx-auto mb-4" /><p className="font-body text-[9px] tracking-[0.2em] uppercase text-white/50">Peer-Reviewed Open Access</p></div></div></motion.div></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6"><span className="w-2 h-2 rounded-full bg-[#DF6D2A]" /><span className="font-body text-[11px] tracking-[0.2em] uppercase text-[#DF6D2A]">Featured Publication</span></div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <h2 className="font-display text-[34px] sm:text-[44px] md:text-[48px] lg:text-[64px] leading-[1] text-[#0F1C2E] mb-4 sm:mb-6">The Official <br /><em className="text-[#C9A84C] italic">Council Journal</em></h2>;
    t14 = <p className="font-body text-[14px] sm:text-[16px] md:text-[17px] text-[#4C596B] leading-[1.7] sm:leading-[1.8] font-light mb-6 sm:mb-8 md:mb-10 max-w-[600px]">The GCJ is an international, peer-reviewed, open-access academic journal dedicated exclusively to the study of the Girmitiya diaspora. We publish high-quality research papers, theoretical essays, and historical analyses.</p>;
    $[13] = t13;
    $[14] = t14;
  } else {
    t13 = $[13];
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="grid grid-cols-2 gap-4 sm:gap-6 md:gap-8 mb-8 sm:mb-10 md:mb-12 border-y border-[#0F1C2E]/10 py-5 sm:py-6 md:py-8"><div><p className="font-body text-[10px] uppercase tracking-[0.1em] text-[#0F1C2E]/50 mb-1">Status</p><p className="font-display text-[17px] sm:text-[20px] md:text-[22px] text-[#0F1C2E]">Open Access</p></div><div><p className="font-body text-[10px] uppercase tracking-[0.1em] text-[#0F1C2E]/50 mb-1">Identifiers</p><p className="font-display text-[17px] sm:text-[20px] md:text-[22px] text-[#0F1C2E]">{"ISSN & DOI Assigned"}</p></div></div>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <section className="bg-[#F4EFE6] py-16 sm:py-24 md:py-32 relative overflow-hidden"><div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12"><div className="flex flex-col lg:flex-row gap-10 sm:gap-12 lg:gap-24 items-center">{t11}<div className="w-full lg:w-[55%] flex flex-col">{t12}{t13}{t14}{t15}<div className="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-3 sm:gap-6"><button className="font-body px-6 sm:px-8 py-3.5 sm:py-4 bg-[#0F1C2E] text-[#F4EFE6] text-[11px] sm:text-[12px] tracking-[0.12em] sm:tracking-[0.15em] uppercase hover:bg-[#DF6D2A] transition-colors duration-300 text-center">Read Latest Issue</button><button className="font-body px-6 sm:px-8 py-3.5 sm:py-4 border border-[#0F1C2E]/20 text-[#0F1C2E] text-[11px] sm:text-[12px] tracking-[0.12em] sm:tracking-[0.15em] uppercase hover:bg-[#0F1C2E]/5 transition-colors duration-300 text-center">View Archive</button></div></div></div></div></section>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  return t16;
};
export default JournalHighlight;